import FilesService from '@/services/atp-files'
import Utils from '@/utils/utils'
import * as types from '../mutations'

const state = {
  files: [],
  isLoadingFiles: false,
  totalFiles: 0
}

const getters = {
  files: (state) => state.files,
  isLoadingFiles: (state) => state.isLoadingFiles,
  totalFiles: (state) => state.totalFiles
}

const actions = {
  async loadFiles ({ commit }, payload) {
    const data = await FilesService.loadFiles(payload)
    const files = data?.results || []
    const count = data?.count || 0

    commit(types.SET_FILES, files)
    commit(types.SET_FILES_COUNT, count)
  },

  setIsLoadingFiles ({ commit }, isLoading) {
    commit(types.SET_IS_LOADING_FILES, isLoading)
  },

  setFiles ({ commit }, files) {
    commit(types.SET_FILES, files)
  }
}

const mutations = {
  [types.SET_FILES] (state, files) {
    if (files.length > 0) {
      state.files = files.map((file) => {
        const statusLower = file?.status?.toLowerCase()
        return {
          ...file,
          active_codes: file?.code_count,
          submitted_at: Utils.formatDate(file?.created_at, false, true),
          source_file: file?.download_url,
          error_log: file?.error_doc_url,
          status: statusLower === 'error' ? 'failed' : statusLower === 'ok' ? 'success'
            : statusLower === 'submitted' ? 'pending' : file?.status
        }
      })
    } else {
      state.files = files
    }
  },

  [types.SET_IS_LOADING_FILES] (state, isLoading) {
    state.isLoadingFiles = isLoading
  },

  [types.SET_FILES_COUNT] (state, count) {
    state.totalFiles = count
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
